import { useState } from 'react'

import Spinner from './Spinner'

interface ImageHelperProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  wrapperClassName?: string
  showSpinner?: boolean
}

function ImageHelper({
  src,
  alt,
  className,
  wrapperClassName = '',
  showSpinner = true,
  ...props
}: ImageHelperProps) {
  const [isLoading, setIsLoading] = useState(true)

  return (
    <Spinner
      spinning={isLoading || showSpinner}
      className={`relative ${wrapperClassName || ''}`}
    >
      <img
        src={src}
        alt={alt}
        className={className}
        onLoad={() => setIsLoading(false)}
        {...props}
      />
    </Spinner>
  )
}

export default ImageHelper

ImageHelper.defaultProps = {
  wrapperClassName: '',
  showSpinner: false
}
